module.exports = __webpack_public_path__ + "static/media/plus-blue-16.f5f313fd.svg";